import apiService from "./apiService";
import AppConstants from "../appConstants";

class CountryService {
    getAllCountry(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_COUNTRY, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getCountryDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_COUNTRY}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerCountry(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_COUNTRY, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteCountry(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_COUNTRY}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_COUNTRY_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new CountryService();
